import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=0d73be18"
import script from "./ProductModel.vue?vue&type=script&lang=js"
export * from "./ProductModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports